import { render, staticRenderFns } from "./DeleteTokenButton.vue?vue&type=template&id=1250306f&"
import script from "./DeleteTokenButton.vue?vue&type=script&lang=js&"
export * from "./DeleteTokenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports